import { databases } from "@/lib/appwrite";
import { isCertificateApproved } from "@/requests/certificates/employmentCertificate/views/config/certificateApprovals";


interface UpdateCertificateByRRHHParams {
    requestId: string;
    action: 'approve' | 'reject';
    rrhhUserId: string;
    rejectionReason?: string;
    certificateType: string;
    currentStatusBySupervisor: string;
    currentStatusByManager: string;
}

export const updateCertificateRequestByRRHH = async ({
    requestId,
    action,
    rrhhUserId,
    rejectionReason,
    certificateType,
    currentStatusBySupervisor,
    currentStatusByManager
}: UpdateCertificateByRRHHParams) => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;

        if (!databaseId || !collectionId) {
            throw new Error("Missing environment variables for database or collection");
        }

        // // Obtener la configuración de aprobaciones para este tipo de certificado
        // const approvalConfig = getApprovalConfig(certificateType);
        // const requiredApprovals = approvalConfig.requiredApprovals;

        // Preparar los datos base de actualización
        const updateData: any = {};

        if (action === 'approve') {
            // APROBACIÓN POR RRHH
            updateData.statusByRrhh = 'approved';
            updateData.idApprovedByRrhh = rrhhUserId;
            
            // Verificar si este certificado ya está completamente aprobado
            // Simular el nuevo estado con RRHH aprobado
            const isFullyApproved = isCertificateApproved(
                certificateType,
                'approved', // RRHH está aprobando ahora
                currentStatusBySupervisor,
                currentStatusByManager
            );

            if (isFullyApproved) {
                // Si ya tiene todas las aprobaciones requeridas, actualizar status y approvedAt
                updateData.status = 'approved';
                updateData.approvedAt = new Date().toISOString();
            } else {
                // Si aún faltan aprobaciones, mantener status como pending
                updateData.status = 'pending';
            }

        } else if (action === 'reject') {
            // RECHAZO POR RRHH
            if (!rejectionReason || rejectionReason.trim() === '') {
                throw new Error("El motivo del rechazo es obligatorio");
            }

            updateData.statusByRrhh = 'rejected';
            updateData.commentsRrhh = rejectionReason;
            updateData.idApprovedByRrhh = rrhhUserId; // Registrar quién rechazó
            
            // Si RRHH rechaza, el status general es rechazado
            // ya que RRHH es requerido en todos los flujos
            updateData.status = 'rejected';
        }

        // Ejecutar la actualización
        const response = await databases.updateDocument(
            databaseId,
            collectionId,
            requestId,
            updateData
        );

        return {
            success: true,
            data: response,
            message: action === 'approve' 
                ? 'Solicitud aprobada exitosamente' 
                : 'Solicitud rechazada exitosamente'
        };

    } catch (error) {
        console.error("Error updating certificate request by RRHH:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Error desconocido al actualizar la solicitud"
        };
    }
};

// Función auxiliar para obtener el estado actualizado de una solicitud
export const getUpdatedCertificateRequest = async (requestId: string) => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;

        const response = await databases.getDocument(
            databaseId,
            collectionId,
            requestId
        );

        return {
            success: true,
            data: response
        };
    } catch (error) {
        console.error("Error getting updated certificate request:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Error al obtener la solicitud"
        };
    }
};